import React from 'react';
import { CircularProgress, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { styled } from '@mui/material/styles';

/**
 * Loading Overlay Component
 */
const Overlay = styled(motion.div)(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: theme.zIndex.modal + 1,
  backdropFilter: 'blur(4px)',
}));

const LoadingContainer = styled(motion.div)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.custom.borderRadius.xl,
  padding: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
  boxShadow: theme.custom.boxShadow['2xl'],
  minWidth: 200,
}));

const LoadingOverlay = ({ 
  open = true, 
  message = 'Loading...', 
  size = 60 
}) => {
  if (!open) return null;

  return (
    <Overlay
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <LoadingContainer
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        transition={{ duration: 0.3 }}
      >
        <CircularProgress size={size} thickness={4} />
        {message && (
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            {message}
          </Typography>
        )}
      </LoadingContainer>
    </Overlay>
  );
};

export default LoadingOverlay;
